/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CalculateResultItem,
  CalculateResultItemFromJSON,
  CalculateResultItemFromJSONTyped,
  CalculateResultItemToJSON,
} from "./";

/**
 *
 * @export
 * @interface CalculateResult
 */
export interface CalculateResult {
  /**
   *
   * @type {Array<CalculateResultItem>}
   * @memberof CalculateResult
   */
  targetGroups: Array<CalculateResultItem>;
  /**
   *
   * @type {Array<CalculateResultItem>}
   * @memberof CalculateResult
   */
  conversionGroups: Array<CalculateResultItem>;
}

export function CalculateResultFromJSON(json: any): CalculateResult {
  return CalculateResultFromJSONTyped(json, false);
}

export function CalculateResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculateResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    targetGroups: (json["targetGroups"] as Array<any>).map(
      CalculateResultItemFromJSON,
    ),
    conversionGroups: (json["conversionGroups"] as Array<any>).map(
      CalculateResultItemFromJSON,
    ),
  };
}

export function CalculateResultToJSON(value?: CalculateResult | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    targetGroups: (value.targetGroups as Array<any>).map(
      CalculateResultItemToJSON,
    ),
    conversionGroups: (value.conversionGroups as Array<any>).map(
      CalculateResultItemToJSON,
    ),
  };
}
